import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {cmenums,cmenum} = api



/**
 * 查找系统枚举
 */
export async function findCMEnums(params) {
    return request({url: cmenums, method: 'get', data: params,})
}

export async function findCMEnum(params) {
    return request({url: cmenum, method: 'get', data: params,})
}



// WEBPACK FOOTER //
// ./src/services/cmenums.js